import React from "react";
import { Header } from "../components/landing/Header";
import { Hero } from "../components/landing/Hero";
import { TrustStrip } from "../components/landing/TrustStrip";
import { Diagnosis } from "../components/landing/Diagnosis";
import { Audience } from "../components/landing/Audience";
import { SystemSteps } from "../components/landing/SystemSteps";
import { VolumeExplorer } from "../components/landing/VolumeExplorer";
import { KanjiBonuses } from "../components/landing/KanjiBonuses";
import { Comparison } from "../components/landing/Comparison";
import { Plans } from "../components/landing/Plans";
import { PlanTable } from "../components/landing/PlanTable";
import { CompleteAdvantages } from "../components/landing/CompleteAdvantages";
import { Delivery } from "../components/landing/Delivery";
import { Faq } from "../components/landing/Faq";
import { FinalCta } from "../components/landing/FinalCta";
import { Footer } from "../components/landing/Footer";
import { MobileBar } from "../components/landing/MobileBar";
export function Landing() {
  return <div className="paper-grain min-h-screen w-full bg-marfil pb-20 text-pizarra-deep md:pb-0" data-id="element-330" data-mp="3tgbgdpln0ys9">
      <a href="#contenido" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-full focus:bg-pizarra-deep focus:px-4 focus:py-2 focus:text-marfil" data-id="element-331" data-mp="3tio46je2u3d8">
        Saltar al contenido
      </a>
      <Header data-id="element-332" data-mp="kz8bxee63via" />
      <main id="contenido" data-id="element-333" data-mp="kzqeesrfb5yn">
        <Hero data-id="element-334" data-mp="gywqhzdzdr5r" />
        <TrustStrip data-id="element-335" data-mp="gyeloed964m8" />
        <Diagnosis data-id="element-336" data-mp="gzzg83zkhnk3" />
        <Audience data-id="element-337" data-mp="gzg8th7jmhkb" />
        <SystemSteps data-id="element-338" data-mp="h112l4m19wh4" />
        <VolumeExplorer data-id="element-339" data-mp="c7y8mvdcgl0e" />
        <KanjiBonuses data-id="element-340" data-mp="c7ep5a81pok9" />
        <Comparison data-id="element-341" data-mp="c6n4gufzlb8r" />
        <Plans data-id="element-342" data-mp="c63k772v6ark" />
        <PlanTable data-id="element-343" data-mp="794ur1u5arzp" />
        <CompleteAdvantages data-id="element-344" data-mp="79n0qq6m0kkt" />
        <Delivery data-id="element-345" data-mp="78bw6o5cb8sn" />
        <Faq data-id="element-346" data-mp="78v3zc1a0gsy" />
        <FinalCta data-id="element-347" data-mp="77aiebwxw878" />
      </main>
      <Footer data-id="element-348" data-mp="14p0wgden62zx" />
      <MobileBar data-id="element-349" data-mp="14pkc1ngtkfas" />
    </div>;
}